import { createContext } from 'react'

export interface State {
  data?: any
}

const initialState = {
  data: null,
}

export const ProductsContext = createContext<State | any>(initialState)

export const ProductsProvider = ProductsContext.Provider
export const ProductsConsumer = ProductsContext.Consumer
